<template>
  <div class="main" v-loading="loading">
    <div class="box_wrap" v-show="isList">
      <div class="box" v-for="item in lista" :key="item.id">
        <div class="box1"></div>
        <div class="img" @click="detli(item)">
          <img :src="item.video_first_url" />
        </div>
        <div class="bai">
          <div class="bai_title_wrap">
            <div class="bai_title">
              {{ item.video_title }}
            </div>
          </div>
          <div class="logo">
            <div class="logo_img">
              <div class="logo1">
                <img :src="item.company_logo" />
              </div>
            </div>
            <div class="log_text">
              {{ item.company_name }}
            </div>
          </div>
          <div style="height: 41px"></div>
          <el-row class="bottom">
            <el-button
              type="primary"
              round
              size="mini"
              class="examine"
              @click="job_details(item)"
              >职位详情</el-button
            >
            <el-button
              type="success"
              round
              size="mini"
              class="examine"
              @click="adopt(item)"
              >通过</el-button
            >
            <el-button
              type="danger"
              size="mini"
              round
              class="examine"
              @click="fail(item)"
              >未通过</el-button
            >
          </el-row>
        </div>
      </div>
    </div>
    <div class="pagination" v-show="isList">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="videoCount"
        :page-size="20"
        @size-change="sizeChange"
        @current-change="onChange"
        @prev-click="prev"
        @next-click="next"
      >
      </el-pagination>
    </div>
    <div class="video_wrap" v-show="show" @click="dj">
      <div class="is_video" @click.stop>
        <video controls="controls" ref="video" :src="baseurl">
          <source src="/i/movie.ogg" type="video/ogg" />
          <source src="/i/movie.mp4" type="video/mp4" />
          <source src="/i/movie.webm" type="video/webm" />
        </video>
      </div>
    </div>
    <div v-show="!isList" class="noList">暂无视频</div>
  </div>
</template>
<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      loading: true,
      page: 0, //页数
      status: 1,
      statusa: 2,
      lista: [], //视频列表
      baseurl: "", //视频地址
      show: false,
      videoCount: 0,
      isList: true,
    };
  },
  created() {
    this.list();
  },
  methods: {
    onChange(val) {
      this.lista = [];
      this.page = val - 1;
      this.loading = true;
      this.list();
    },
    // 当前页发生变化
    sizeChange(val) {
      console.log(val);
    },
    // 上一页
    prev() {
      this.lista = [];
      this.loading = true;
      this.page--;
      this.list();
    },
    // 下一页
    next() {
      this.lista = [];
      this.loading = true;
      this.page++;
      this.list();
    },
    //视频列表
    list() {
      let obj = {
        page: this.page,
      };
      require("post", "/hr24_index_data/v1/video_list/", obj).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.lista = res.data.video_list;
          this.loading = false;
          this.videoCount = res.data.video_count;
          if (res.data.video_count == 0) {
            this.isList = false;
          }
          if (this.lista.length == 0 && this.videoCount != 0) {
            this.page--;
            this.list();
          }
        }
      });
    },
    //视频详情
    detli(item) {
      this.loading = true;
      // console.log(item);
      let obj = { video_id: item.id };
      require("post", "/hr24_index_data/v1/video_detail/", obj).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.baseurl = res.data.video_url;
          this.show = true;
          this.loading = false;
          var _this = this;
          setTimeout(function () {
            _this.$refs.video.play();
          }, 2000);
        }
      });
    },
    dj() {
      this.show = false;
      this.$refs.video.pause();
    },
    //审核视频通过
    adopt(item) {
      this.$confirm("是否确认审核", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(item);
          let obj = {
            video_id: item.id,
            status: this.status,
          };
          this.loading = true;
          require("post", "/hr24_index_data/v1/video_audit/", obj).then(
            (res) => {
              console.log(res);
              if (res.code == 0) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.list();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "warning",
            message: "已取消操作",
          });
        });
    },
    // 审核未通过
    fail(item) {
      this.$prompt("驳回理由(200字以内)", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入",
        inputValidator: (value) => {
          // 点击按钮时，对文本框里面的值进行验证
          if (!value) {
            return "输入不能为空";
          } else if (value.length >= 200) {
            return "不可以超过200字";
          } else if (value.substr(0, 1) == " ") {
            return "不可以以空格开头";
          }
        },
      })
        .then(({ value }) => {
          this.loading = true;
          let obj = {
            video_id: item.id,
            status: this.statusa,
            remarks: value,
          };
          console.log(value);
          require("post", "/hr24_index_data/v1/video_audit/", obj).then(
            (res) => {
              console.log(res);
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.list();
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "warning",
            message: "已取消",
          });
        });
    },
    //跳转到职位详情
    job_details(item) {
      console.log(item);
      this.$router.push({
        path: "/details",
        query: { id: item.jd_primary_id },
      });
      // sessionStorage.setItem("id", 1);
    },
  },
  activated(){
    console.log('1')
  }
};
</script>

<style scoped>
p {
  margin: 3px;
}
img {
  vertical-align: top;
  width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0;
}
.main {
  position: relative;

  /* justify-self: start; */
}
.box_wrap {
  display: flex;
  flex-wrap: wrap;
}
.box {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 10%);
  position: relative;
  /* border: 0.5px solid; */
  width: 220px;
  margin-left: 20px;
  margin-top: 20px;
  background: white;
  /* margin-top: 0px; */
  /* background: orange; */
  /* border-radius:10px;   */
}
.box1 {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 220px;
  height: 403px;
  background: gray;
  opacity: 0.5;
  display: none;
}
.box:hover {
  /* box-shadow: 0 0px 3px 4px rgba(64,93,230,0.6); */
  /* background: gray; */
  opacity: 0.7;
  display: block;
  border-radius: 10px;
}
.img {
  width: 220px;
  height: 293.333px;
}
.bai {
  width: 220px;
  /* background: white; */
  border-radius: 0 0 10px 10px;
  margin: 0;
}
.bai_title_height {
  display: none;
  height: 40px;
}
.bai_title_wrap {
  margin: 5px;
}
.bai_title_wrap:hover .bai_title {
  display: block;
  height: auto;
  background-color: #fff;
  height: 80px;
}

.bai_title_wrap:hover + .logo {
  height: 0;
  overflow: hidden;
  margin: 0;
}

.bai_title_wrap:hover .bai_title_height {
  display: block;
}
.bai_title {
  transition: all 0.5s;
  height: 40px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 15px;
}
.logo {
  transition: all 0.5s;
  padding: 0 10px;
  display: flex;
  height: 28px;
  margin-top: 10px;
  margin-bottom: 10px;
  align-items: center;
  /* background: red; */
}
.logo1 {
  display: flex;
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.logo1 img {
  border-radius: 50%;
}
.logo1 p {
  line-height: 26px;
  margin-left: 10px;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.examine {
  margin-bottom: 8px;
  margin-left: 2px;
}
.video_wrap {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.is_video {
  width: 24vw;
}
.is_video video {
  width: 100%;
  height: auto;
}
.log_text {
  font-size: 12px;
  margin-left: 10px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.bottom {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.pagination {
  display: flex;
  justify-content: center;
  margin: 50px 0;
}
.noList {
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #aaa;
}
</style>



// WEBPACK FOOTER //
// src/user_management/audit_video.vue